<div class="default-teams-container flex-column flex-fill">

  @if (openedWarning) {
  <kendo-dialog title="Please confirm" (close)="onWarningClose()" [minWidth]="250" [width]="450">
    <div>
      <p>All projects synced to the modified Default Project Team(s) will be updated regardless of project status. Proceed with Default Project Team role changes?</p>
    </div>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="onWarningClose()">No</button>
      <button type="button" kendoButton (click)="onWarningSave()">Yes</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  }

  @if (openedTeamDialogError) {
  <kendo-dialog title="Team Selection Error" (close)="closeTeamDialog()">
    <p style="margin: 30px; text-align: center;">{{teamDialogMessage}}.</p>
  </kendo-dialog>
  }

  @if (openConflicts) {
  <kendo-dialog title="Action Required" (close)="closeConflictsDialog()" [width]="800">
    <div class="alert alert-warning" role="alert">
      <h4 class="alert-heading">Attention</h4>
      <p>One or more projects as listed below contain a Segregation of Duties (SOD) violation. The person assigned in the Project Tech role of the selected Default Project Team is the Financial Approver. The Financial Approver and Project Tech for a Project cannot be the same person.</p>
      <p>If you Proceed, any project(s) without a conflict will remain synced and the project team members will be replaced with those in the revised Default Project Team. Any project(s) with a conflict will be unsynced and changed to Custom. No personnel changes will be made to those with a conflict.</p>
      <p>If you select Close, no changes will be made to any project or to the Default Project Team.</p>
    </div>
    <kendo-grid
      [data]="conflictingProjects"
      [pageSize]="conflictGridState.take"
      [skip]="conflictGridState.skip"
      [sortable]="true"
      [sort]="conflictGridState.sort"
      [resizable]="true"
      [height]="400">
      <ng-template kendoGridToolbarTemplate>
        <button type="button" kendoGridExcelCommand [svgIcon]="icons.excel">Export to Excel</button>
      </ng-template>
      <kendo-grid-column field="DefaultProjectTeam" [width]="160" title="Team"></kendo-grid-column>
      <kendo-grid-column field="ProjectTechCurrent" [width]="170" title="Current Project Tech"></kendo-grid-column>
      <kendo-grid-column field="ProjectTechNew" [width]="170" title="New Project Tech"></kendo-grid-column>
      <kendo-grid-column field="TotalProjects" [width]="75" title="Conflicts"></kendo-grid-column>
      <kendo-grid-column [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <button type="button" (click)="updateTeamWithConflict(dataItem.ResolutionRequest)" class='k-button k-primary'>Update</button>
        </ng-template>
      </kendo-grid-column>
      <div *kendoGridDetailTemplate="let dataItem">
        <kendo-grid
          [data]="dataItem.Projects"
          [pageSize]="conflictDetailGridState.take"
          [skip]="conflictDetailGridState.skip"
          [pageable]="true"
          [scrollable]="'none'">
          <kendo-grid-column field="ProjectId" title="Project ID" [width]="120">
          </kendo-grid-column>
          <kendo-grid-column field="ProjectName" title="Project Name">
          </kendo-grid-column>
        </kendo-grid>
      </div>
      <kendo-grid-excel fileName="ProjectInConflict.xlsx" [fetchData]="excelExportAllData">
        <kendo-excelexport-column field="ProjectId" title="Project ID"></kendo-excelexport-column>
        <kendo-excelexport-column field="ProjectName" title="Project Name"></kendo-excelexport-column>
      </kendo-grid-excel>
    </kendo-grid>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="closeConflictsDialog()" themeColor="primary">Close</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  }
  <!-- [editService]="projectTeamService"  -->
  @if (showValidationMessage) {
  <div class="alert alert-danger">{{ validationMessage }}</div>
  }
  <app-header [title]="'Project Teams'" [loading]="loading">
    <button type="button" kendoButton themeColor="primary" class="me-1" (click)="addNewTeam()">Add New</button>
    <button type="button" kendoButton class="corneredbutton" [disabled]="editedTeams.size <= 0" themeColor="primary" class="me-1" (click)="saveChanges()">Save</button>
    @if (editedTeams.size > 0) {
    <button type="button" kendoButton themeColor="primary" class="me-1" (click)="cancelEdit()">Cancel</button>
    }
  </app-header>
  <ag-grid-angular #agGrid style="height: 100%;" class="ag-theme-balham"
    [gridOptions]="projectTeamGridOptions" (cellValueChanged)="onCellValueChanged($event)" (rowEditingStopped)="onRowEditStopped($event)">
  </ag-grid-angular>

</div>